<template>
  <div class="admin-layout-footer">
    <span class="copyright">
      &copy; 2022 Element Admin. All Rights Reserved
    </span>
  </div>
</template>
<script>
export default {
  name: 'AdminLayoutFooter',
};
</script>
<style lang="less">
.admin-layout-footer {
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: var(--ea-text-color-secondary);
}
</style>